import React, { useState, useRef } from 'react';
import { useScript } from '../context/ScriptContext';
import { useAuth } from '../context/AuthContext';
import * as api from '../services/api';

interface ImageUploadProps {
  imageUrl: string;
  onImageUrlChange: (url: string) => void;
  label?: string;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ imageUrl, onImageUrlChange, label }) => {
  const { t } = useScript();
  const { token } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !token) return;

    setUploading(true);
    setError('');
    try {
      const result = await api.uploadImage(token, file);
      onImageUrlChange(result.url);
    } catch {
      setError(t('Грешка при отпремању слике.'));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div>
      {label && <label className="post-admin-label">{label}</label>}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          className="news-edit-input"
          type="text"
          placeholder="https://... or /uploads/..."
          aria-label={label || t('URL слике')}
          value={imageUrl}
          onChange={e => onImageUrlChange(e.target.value)}
          style={{ flex: 1 }}
        />
        <label className="btn-secondary" style={{ cursor: 'pointer', whiteSpace: 'nowrap', margin: 0 }}>
          {uploading ? t('...') : t('Отпреми')}
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            aria-label={t('Отпреми слику са рачунара')}
            style={{ display: 'none' }}
          />
        </label>
      </div>
      {error && <p style={{ color: '#8a1c1c', fontSize: '0.85rem', margin: '4px 0 0' }}>{error}</p>}
    </div>
  );
};

export default ImageUpload;
